import { render } from "./2LoanShark.vue?vue&type=template&id=48fa4ff8"
import script from "./2LoanShark.vue?vue&type=script&lang=js"
export * from "./2LoanShark.vue?vue&type=script&lang=js"
script.render = render

export default script